import type {
  DiscoverIntelSourceResponse,
  IntelPlatform,
  IntelSource,
  IntelSourceData,
} from '../generated/api/types.gen.js';
import type { BadgeVariant } from '../components/ui/Badge.js';

/**
 * Intel source shapes are the generated API contract. The hand-written copies these replaced used
 * snake_case names (`last_content_at`, `overall_score`, `follower_count`, …) that the camelCase API
 * never sent, so every one of those fields read `undefined` in the UI.
 */
export type { IntelSource, IntelSourceData };
export type IntelSourcePlatform = IntelPlatform;
export type IntelSourceDiscoveryResult = DiscoverIntelSourceResponse;

export type IntelSourceCategory = 'social' | 'on_chain' | 'institutional' | 'research' | 'defi' | 'market_infra';

export const CATEGORY_LABELS: Record<IntelSourceCategory, string> = {
  social: 'Social',
  on_chain: 'On-Chain',
  institutional: 'Institutional',
  research: 'Research',
  defi: 'DeFi',
  market_infra: 'Market Infra',
};

/** A source category as a `Badge` variant (the semantic palette, never raw colours). */
export const CATEGORY_BADGE_VARIANTS: Record<IntelSourceCategory, BadgeVariant> = {
  social: 'info',
  on_chain: 'purple',
  institutional: 'warning',
  research: 'success',
  defi: 'accent',
  market_infra: 'teal',
};
